var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMixed = function SvgPaymentMixed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "6 11.5 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h28a1.5 1.5 0 0 1 1.5 1.5v17A1.5 1.5 0 0 1 36 32H8a1.5 1.5 0 0 1-1.5-1.5v-17A1.5 1.5 0 0 1 8 12Z",
    fill: "#F0F0F1",
    stroke: "#525656"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 27.5,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#525656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 15.5H6v5h32v-5Z",
    fill: "#525656"
  })));
};
export default SvgPaymentMixed;